"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("digi-quiz-player-js");
// Core
var react_1 = __importDefault(require("react"));
// Config
var app_settings_1 = require("../../config/app.settings");
var quizPlayer_config_1 = require("../../config/quizPlayer.config");
// Services
var quiz_service_1 = __importStar(require("../../services/quiz.service"));
/**
 * Quiz player component
 */
var QuizPlayer = /** @class */ (function (_super) {
    __extends(QuizPlayer, _super);
    /**
     * Quiz player constructor
     * @param props
     */
    function QuizPlayer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            displayRetryButton: false,
            displayScore: false,
            userScore: 0,
        };
        _this.timerCount = quizPlayer_config_1.DEFAULT_QUIZ_TIMER_VALUE;
        _this.currentQuestion = 1;
        _this.IuserAnswers = {};
        _this.quizFinished = false;
        _this.isGeneratedQuiz = false;
        _this.handleRetryQuiz = function () {
            _this.removeQuizDataAndReloadPage(_this.props.id);
        };
        /**
         * Handle end quiz action
         * @param evt
         */
        _this.handleEndQuiz = function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var userScore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getQuizCorrection(evt)];
                    case 1:
                        userScore = _a.sent();
                        this.props.handleEndQuiz(__assign(__assign({}, evt.detail), { userScore: userScore }));
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Quiz player initialization
         */
        _this.init = function () {
            // tslint:disable-next-line: no-console
            var element = document.getElementById(_this.props.id);
            if (!element) {
                throw Error("No div container for display quiz");
            }
            window.quizPlayerInit(_this.buildDataFromApiToPlayer(_this.props.content), element);
        };
        /**
         * Handle next question click
         * @param evt
         */
        _this.handleNextQuestion = function (evt) {
            if (_this.props.quizIsLock) {
                _this.blockQuiz();
            }
            if (_this.props.handleNextQuestion && !_this.props.quizIsLock) {
                _this.props.handleNextQuestion(evt);
            }
        };
        /**
         * Block next question click
         */
        _this.blockQuiz = function () {
            setTimeout(function () {
                _this.disableElementClick("#quiz > div.quiz-bottom > div button.btn-next.arrow");
                _this.disableElementClick("#quiz > div.quiz-bottom button.btn-next", _this.props.quizLockCallback);
            }, 500);
        };
        /**
         * Disable click on explanation
         */
        _this.blockExplanation = function () {
            _this.disableElementClick("#quiz > div.quiz-bottom > div:nth-child(2) > div > div > button");
            _this.disableElementClick("#quiz > div.quiz-bottom div.btn-explanation-wrapper > button", _this.props.explanationLockCallback);
        };
        /**
         * Disable click on element QuizPlayer and launch callback
         * @param elementSelector
         * @param callback
         */
        _this.disableElementClick = function (elementSelector, callback) {
            var element = document.querySelector(elementSelector);
            if (element) {
                element.addEventListener("click", function (evt) {
                    evt.target.removeAttribute("disabled");
                    evt.preventDefault();
                    evt.stopPropagation();
                    if (callback) {
                        callback();
                    }
                });
                return true;
            }
            return false;
        };
        /**
         * Return question correction from api
         * @param evt
         */
        _this.getQuestionCorrection = function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.props.quizIsLock) return [3 /*break*/, 2];
                        url = this.isGeneratedQuiz ?
                            app_settings_1.LEARNING_API_ENPOINT + "/questions/##questionId##/validate" : app_settings_1.LEARNING_API_ENPOINT + "/questions/##questionId##/correction";
                        return [4 /*yield*/, quiz_service_1.default.getQuestionCorrection(evt, url, this.isGeneratedQuiz)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.props.quizLockCallback();
                        if (evt.detail && evt.detail.cancel) {
                            evt.detail.cancel();
                        }
                        _a.label = 3;
                    case 3:
                        if (this.props.explanationIsLock) {
                            this.blockExplanation();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Return quiz correction from api
         * @param evt
         */
        _this.getQuizCorrection = function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.props.quizIsLock) return [3 /*break*/, 2];
                        return [4 /*yield*/, quiz_service_1.default.getQuizCorrection(evt, this.props.content.id, this.isGeneratedQuiz)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.setState({ displayScore: true, userScore: result.userScore });
                            if (this.props.displayRetryButton) {
                                this.setState({ displayRetryButton: true });
                            }
                            return [2 /*return*/, result.userScore];
                        }
                        return [2 /*return*/, 0];
                    case 2:
                        this.props.quizLockCallback();
                        if (evt.detail && evt.detail.cancel) {
                            evt.detail.cancel();
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Build data from Api to player
         * @param dataFromApi Json data from api
         */
        _this.buildDataFromApiToPlayer = function (dataFromApi) {
            var generatedQuiz = dataFromApi.generatedQuiz;
            _this.isGeneratedQuiz = !!generatedQuiz;
            var quiz = {
                id: generatedQuiz ? generatedQuiz.id : dataFromApi.id,
                name: generatedQuiz ? generatedQuiz.name : dataFromApi.name,
                score: generatedQuiz ? generatedQuiz.scorePercentage || generatedQuiz.scoreBasic : dataFromApi.score,
                totalScore: generatedQuiz ? generatedQuiz.totalScore : dataFromApi.totalScore,
            };
            var user = {
                answers: _this.IuserAnswers,
                audioActive: false,
                autoPlay: true,
                correctionStepByStep: _this.props.correctionStepByStep,
                currentQuestion: _this.currentQuestion || 1,
                finish: _this.quizFinished,
                name: "anonymous",
                requiredAnswer: _this.props.requiredAnswer,
                showCorrection: typeof _this.props.showCorrection !== "undefined" ? _this.props.showCorrection : true,
                showFinalScore: _this.props.showFinalScore,
                totalQuestion: generatedQuiz ? generatedQuiz.questionCount : dataFromApi.questionCount,
                userScore: _this.state.userScore,
            };
            var questions = dataFromApi.questions;
            var correction = { correction: {}, selection: 0 };
            return {
                correction: correction,
                questions: questions,
                quiz: quiz,
                timer: { currentTime: _this.timerCount, originTime: _this.timerCount },
                user: user,
            };
        };
        /**
         * Get a user quiz progression info
         * @param quizId - quiz identifier
         */
        _this.getUserQuizProgressionInfo = function (quizId) {
            var localData = _this.getUserIQuizDataFromLocalStore();
            if (localData) {
                return localData[quizId];
            }
            return;
        };
        /**
         * Reset user quiz progression
         * @param quizId
         */
        _this.resetUserQuizProgression = function (quizId) {
            var localData = _this.getUserIQuizDataFromLocalStore();
            if (localData) {
                delete localData[quizId];
                localStorage.setItem(app_settings_1.QUIZ_PLAYER_USER_DATA_KEY, JSON.stringify(localData));
            }
        };
        /**
         * Get user quiz data from localstorage
         */
        _this.getUserIQuizDataFromLocalStore = function () {
            var localData = localStorage.getItem(app_settings_1.QUIZ_PLAYER_USER_DATA_KEY);
            if (localData) {
                return JSON.parse(localData);
            }
            return;
        };
        var userQuizInfo = _this.getUserQuizProgressionInfo(props.content.id);
        if (userQuizInfo) {
            _this.currentQuestion = props.currentQuestion || userQuizInfo.currentQuestion;
            _this.quizFinished = userQuizInfo.finish || userQuizInfo.currentQuestion > userQuizInfo.totalQuestion;
            _this.IuserAnswers = userQuizInfo.answers;
            _this.state = __assign(__assign({}, _this.state), { userScore: userQuizInfo.userScore });
        }
        return _this;
    }
    /**
     * QuizPlayer loading and listener event initialization on component mounting
     */
    QuizPlayer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.init();
                document.addEventListener(quiz_service_1.QUIZ_EVENTS.QUIZ_PLAYER_QUESTION_CORRECTION, this.getQuestionCorrection);
                document.addEventListener(quiz_service_1.QUIZ_EVENTS.QUIZ_PLAYER_END_QUIZ, this.handleEndQuiz);
                document.addEventListener(quiz_service_1.QUIZ_EVENTS.ON_CLICK_NEXT_QUESTION, this.handleNextQuestion);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Component update props handler
     * @param props
     */
    QuizPlayer.prototype.componentDidUpdate = function (props) {
        // TODO do better retry quiz
        if (this.props.retryQuiz && props.retryQuiz !== this.props.retryQuiz) {
            this.removeQuizDataAndReloadPage();
        }
    };
    /**
     * Remove all listener on unmount
     */
    QuizPlayer.prototype.componentWillUnmount = function () {
        document.removeEventListener(quiz_service_1.QUIZ_EVENTS.QUIZ_PLAYER_QUESTION_CORRECTION, this.getQuestionCorrection);
        document.removeEventListener(quiz_service_1.QUIZ_EVENTS.QUIZ_PLAYER_END_QUIZ, this.handleEndQuiz);
        document.removeEventListener(quiz_service_1.QUIZ_EVENTS.ON_CLICK_NEXT_QUESTION, this.handleNextQuestion);
    };
    /**
     * Quiz player render method
     */
    QuizPlayer.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { id: this.props.id }),
            this.state.displayRetryButton
                && react_1.default.createElement("button", { id: "retry-btn", onClick: this.handleRetryQuiz }, "Recommencer le quiz")));
    };
    QuizPlayer.prototype.removeQuizDataAndReloadPage = function (quizId) {
        this.resetUserQuizProgression(quizId || this.props.retryQuiz);
        window.location.reload();
    };
    return QuizPlayer;
}(react_1.default.Component));
exports.default = QuizPlayer;
//# sourceMappingURL=QuizPlayer.js.map